import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

/**
 * Le titre d'un écran et la phrase qui dit à quoi il sert.
 *
 * Un seul composant pour les cinq écrans : sans lui, chacun redéfinissait sa
 * propre variante — « Membres » en h2, « Mon compte » sans titre du tout, et
 * la collection avec un h1 centré au milieu de la page. Trois façons de
 * commencer une page dans le même produit, ça se lit comme trois produits.
 *
 * 🔑 Le titre est un `h1`, un par écran. Les écrans en avaient soit un h2 sans
 * h1 au-dessus, soit rien : un lecteur d'écran annonçait alors une page sans
 * titre, et la navigation par titres — la façon dont on parcourt une page
 * quand on ne la voit pas — n'avait aucun point d'entrée.
 */
export default function EnTetePage({ titre, intro = null }) {
  return (
    <Box sx={{ mb: 4 }}>
      <Typography component="h1" variant="h2" gutterBottom>
        {titre}
      </Typography>
      {intro && (
        <Typography
          component="p"
          variant="subtitle1"
          sx={{
            // ⚠️ « body1 » vaut 14 px dans ce thème : à la largeur d'un écran
            // de bureau, une phrase d'introduction y devient une note de bas
            // de page. 16 px, et une couleur adoucie pour qu'elle reste
            // second par rapport au titre.
            color: 'text.secondary',
            // Une ligne de plus de 75 caractères se relit mal : l'œil perd
            // le début de la suivante. La mesure vaut pour un paragraphe,
            // pas pour un tableau, qui lui a besoin de toute la largeur.
            maxWidth: '68ch',
          }}
        >
          {intro}
        </Typography>
      )}
    </Box>
  );
}

EnTetePage.propTypes = {
  titre: PropTypes.string.isRequired,
  // ⛔ Pas de `defaultProps` : React 19 les a SUPPRIMÉES pour les composants
  // fonction, elles ne feraient rien. La valeur par défaut est dans la
  // signature. La règle ESLint est plus vieille que ce changement.
  // eslint-disable-next-line react/require-default-props
  intro: PropTypes.string,
};
